import type { ApiCallerT } from "shared/infrastructure/api/types";

import type {
  GetRequestDetailResponseT,
  GetRequestFilesResponseT,
  GetVacationRequestsResponseT,
  UpdateVacationRequestResponseT,
  VacationRequestsApiT,
} from "../types/vacationRequests.types";

import { generateAbsenceUrlBaseV2 } from "utils/utils";

export const createVacationRequestsApi = (
  apiCaller: ApiCallerT,
): VacationRequestsApiT => ({
  getVacationRequests: async (
    colaboraInstanceId,
    { startDate, endDate, periodTypeId } = {},
  ) => {
    const params = new URLSearchParams({
      visibility: "Company",
      expand: "collaborator,leader",
    });

    if (periodTypeId) params.set("periodTypeId", periodTypeId);
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);

    const url = generateAbsenceUrlBaseV2(`requests?${params.toString()}`);

    const response = await apiCaller<GetVacationRequestsResponseT>(
      url,
      "GET",
      {},
      {},
      {
        "X-Instance-Id": colaboraInstanceId,
      },
    );

    return response;
  },
  getRequestDetail: async (requestId, colaboraInstanceId) => {
    const url = generateAbsenceUrlBaseV2(
      `requests/${requestId}?expand=collaborator,leader,overlapping,balance`,
    );

    const response = await apiCaller<GetRequestDetailResponseT>(
      url,
      "GET",
      {},
      {},
      {
        "X-Instance-Id": colaboraInstanceId,
      },
    );

    return response;
  },
  getRequestFiles: async (requestId, colaboraInstanceId) => {
    const url = generateAbsenceUrlBaseV2(`requests/${requestId}/documents`);

    const response = await apiCaller<GetRequestFilesResponseT>(
      url,
      "GET",
      {},
      {},
      {
        "X-Instance-Id": colaboraInstanceId,
      },
    );

    return response;
  },
  updateVacationRequest: async (data, colaboraInstanceId) => {
    const url = generateAbsenceUrlBaseV2("requests/status");

    const response = await apiCaller<UpdateVacationRequestResponseT>(
      url,
      "PATCH",
      data,
      {},
      {
        "X-Instance-Id": colaboraInstanceId,
      },
    );

    return response;
  },
});
